export const EMPTY_MILES_STATUS_ID = 51;
export const LEGACY_EMPTY_MILES_STATUS_ID = 26;

export const isEmptyMilesStop = (stop) =>
  [EMPTY_MILES_STATUS_ID, LEGACY_EMPTY_MILES_STATUS_ID].includes(
    Number(stop?.status_id)
  );

export const normalizeStopsOrder = (items = []) =>
  items.map((item, index) => ({
    ...item,
    order: index + 1,
  }));

const toCoordinateNumber = (value) => {
  const parsed = parseFloat(value);
  return Number.isNaN(parsed) ? null : parsed;
};

const getStopCoordinates = (stop) => {
  const lat = toCoordinateNumber(stop?.lat);
  const lng = toCoordinateNumber(stop?.lng);

  if (lat === null || lng === null) {
    return null;
  }

  return { lat, lng };
};

const normalizeMileValue = (value) => {
  const parsed = parseFloat(value);

  if (Number.isNaN(parsed)) {
    return 0;
  }

  return Number(parsed.toFixed(2));
};

export const calculateDrivingMilesBetweenStops = async (
  originCoords,
  destinationCoords
) => {
  if (!window.google?.maps) {
    throw new Error("Google Maps is not available");
  }

  const service = new window.google.maps.DistanceMatrixService();
  const origin = new window.google.maps.LatLng(originCoords.lat, originCoords.lng);
  const destination = new window.google.maps.LatLng(
    destinationCoords.lat,
    destinationCoords.lng
  );

  return new Promise((resolve, reject) => {
    service.getDistanceMatrix(
      {
        origins: [origin],
        destinations: [destination],
        travelMode: "DRIVING",
        unitSystem: window.google.maps.UnitSystem.IMPERIAL,
      },
      (response, status) => {
        const meters = response?.rows?.[0]?.elements?.[0]?.distance?.value;

        if (status === "OK" && typeof meters === "number") {
          resolve(Number((meters / 1609.34).toFixed(2)));
          return;
        }

        reject(new Error("Error calculating distance between stops"));
      }
    );
  });
};

export const recalculateStopsMiles = async (
  items = [],
  { preserveGeneratedFirstStopMiles = true } = {}
) => {
  const orderedStops = normalizeStopsOrder(items);

  if (orderedStops.length === 0) {
    return orderedStops;
  }

  const recalculatedStops = [];

  for (let index = 0; index < orderedStops.length; index += 1) {
    const currentStop = orderedStops[index];

    if (index === 0) {
      recalculatedStops.push({
        ...currentStop,
        mile: 0,
      });
      continue;
    }

    const previousStop = orderedStops[index - 1];
    const previousCoords = getStopCoordinates(previousStop);
    const currentCoords = getStopCoordinates(currentStop);

    if (!previousCoords || !currentCoords) {
      recalculatedStops.push({
        ...currentStop,
        mile: normalizeMileValue(currentStop.mile),
      });
      continue;
    }

    try {
      const nextMiles = await calculateDrivingMilesBetweenStops(
        previousCoords,
        currentCoords
      );

      if (isEmptyMilesStop(previousStop)) {
        recalculatedStops[recalculatedStops.length - 1] = {
          ...recalculatedStops[recalculatedStops.length - 1],
          mile: normalizeMileValue(nextMiles),
        };

        recalculatedStops.push({
          ...currentStop,
          mile: 0,
        });
        continue;
      }

      recalculatedStops.push({
        ...currentStop,
        mile: normalizeMileValue(nextMiles),
      });
    } catch (error) {
      console.error(error);
      recalculatedStops.push({
        ...currentStop,
        mile: normalizeMileValue(currentStop.mile),
      });
    }
  }

  return recalculatedStops;
};
